import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";
import { priceListListQuery } from "@/features/price-lists/api";
import { PriceListsPage } from "@/features/price-lists/PriceListsPage";
import { validatePriceListSearch, type PriceListSearch } from "@/features/price-lists/search";
import { activeCompanyOf } from "@/lib/activeCompany";
import { sessionContextQuery } from "@/lib/session";

// Sales → Master data → Price lists (PX-SAL-320, ADR-049).

export const Route = createFileRoute("/_app/sales/price-lists")({
  validateSearch: (raw: Record<string, unknown>) => validatePriceListSearch("sales", raw),
  loaderDeps: ({ search }) => ({ status: search.status, q: search.q }),
  loader: async ({ context, deps }) => {
    const ctx = await context.queryClient.ensureQueryData(sessionContextQuery);
    const companyId = activeCompanyOf(ctx)?.id;
    if (companyId)
      await context.queryClient.ensureInfiniteQueryData(priceListListQuery({ kind: "sales", companyId, status: deps.status, q: deps.q }));
  },
  component: Page,
});

function Page() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const setSearch = useCallback(
    (patch: Partial<PriceListSearch>) => void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true }),
    [navigate],
  );
  return <PriceListsPage kind="sales" search={search} setSearch={setSearch} />;
}
